<template>
        <label class="switch">
                <input type="checkbox" :value="value" @click="toggleCheckbox">
                <div class="slider round"></div>
        </label>
</template>

<script setup>
        import { ref, defineEmits } from "vue"

        const checkbox = ref(false)
        const emit = defineEmits(['update:modelValue'])
        const props = defineProps({
         modelValue: {
              type: Boolean,
              default: false
            },
        })

        const value = ref(props.modelValue)
        
        const toggleCheckbox = () => {
                value.value = !value.value
                emit('update:modelValue', value.value);
        }
</script>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 28px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #87F57D;
}

input:focus + .slider {
  box-shadow: 0 0 1px #101010;
}

input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>